import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components";
import {ChartWidget} from "./chart";
import {StakeTopContext} from "../../contexts/farm_provider/stake_top_provider";


export interface PieChartWapInterFace {
    title: string;
    list: { name: string, value: number, color: string }[],
    totalNumner?:number
}

export const PieChartWapWidget: React.FC<PieChartWapInterFace> = ({title,list,children,totalNumner}) => {

    const {total, staked, userAllStakeBalance} = useContext(StakeTopContext);
    const [listDara,setListData] = useState(()=> {
        return list;
    });

    useEffect(()=>{
        setListData(list);
    },[
        userAllStakeBalance,
        staked,
        total,
    ]);

    return (
        <StylePieChart>
            <StyleTis>{title}</StyleTis>
            <StyleCenter>
                <div style={{zIndex:100}}><ChartWidget title={title} totalNumner={totalNumner} list={listDara}/></div>
                <div className='center' style={{width:"100px",height:"100px"}}>{children}</div>
            </StyleCenter>
            <div style={{"display": 'flex', justifyContent: 'flex-end'}}>
                {
                    list.map((ev)=>  <Annotation color={ev.color} key={ev.name}>{ev.name}</Annotation>)
                }
            </div>

        </StylePieChart>
    );
};

const Annotation: React.FC<{color:string}> = (ev) => {
    return (
        <StyleAnnotation bg={ev.color}>
            <span/>
            <p>{ev.children}</p>
        </StyleAnnotation>
    );
};


const StyleCenter = styled.div`
display: flex;
justify-content: center;
position: relative;
padding: 20px 0;

.center{
position: absolute;
top: 0;
bottom: 0;
left: 0;
right: 0;
margin: auto;
display: flex;
flex-flow: column;
align-items: center;
justify-content: center;
.sub_title{
font-size: 10px;
font-weight: 400;
color: ${(props)=>props.theme.color.whites[100]};
}
.number24{
font-size: 20px;
font-weight: 500;
color: ${(props)=>props.theme.color.whites[100]};
}
.number20{
font-size: 18px;
font-weight: 500;
color: ${(props)=>props.theme.color.whites[100]};
}
.staked{
font-weight: 500;
color: #FFFFFF;
line-height: 30px;

}
}
`;


const StylePieChart = styled.div`
background: #142144;
border: 1px solid #273761;
border-radius: 4px;
padding: 25px;
width: 43%;
@media (max-width: 768px) {
 width: 80%;
 margin: 0 auto;
  };
`;

const StyleTis = styled.div`
font-size: 18px;
font-weight: 400;
color: ${(props) => props.theme.color.whites[100]};
`;


const StyleAnnotation = styled.div<{ bg: string }>`
background: #1D2D56;
padding: 4px 6px;
min-width: 80px;
margin-left: 20px;
border-radius: 4px;
display: flex;
    align-items: center;
span{
width: 10px;
height: 10px;
background: ${(props) => props.bg};
border-radius: 2px;
}
p{
padding-left: 10px;
box-sizing: border-box;
font-size: 12px;
font-weight: 400;
color: ${(props) => props.theme.color.whites[100]};

}

`;


